// Small imperative bus so the InstanceQueueIndicator (which lives
// inside AppHeader, rendered from ~7 different screens) can reach
// app-level actions without every screen needing to plumb more
// props through AppHeader.
//
// App.jsx registers handlers once on mount; every Indicator
// instance pulls them off this module by function reference.

let onOpenInstanceHandler = null;
let onAcceptInstanceInviteHandler = null;
let onAcceptDraftInviteHandler = null;
let onAcceptDraftMatchInviteHandler = null;

export function registerInstanceQueueHandlers({
  onOpenInstance,
  onAcceptInstanceInvite,
  onAcceptDraftInvite,
  onAcceptDraftMatchInvite,
} = {}) {
  onOpenInstanceHandler = onOpenInstance || null;
  onAcceptInstanceInviteHandler = onAcceptInstanceInvite || null;
  onAcceptDraftInviteHandler = onAcceptDraftInvite || null;
  onAcceptDraftMatchInviteHandler = onAcceptDraftMatchInvite || null;
}

export function openInstance(inst) {
  if (onOpenInstanceHandler) onOpenInstanceHandler(inst);
}

export function acceptInstanceInvite(senderId, msg) {
  if (onAcceptInstanceInviteHandler) onAcceptInstanceInviteHandler(senderId, msg);
}

export function acceptDraftInvite(eventId, msg, opts) {
  if (onAcceptDraftInviteHandler) onAcceptDraftInviteHandler(eventId, msg, opts);
}

export function acceptDraftMatchInvite(eventId, matchId) {
  if (onAcceptDraftMatchInviteHandler) onAcceptDraftMatchInviteHandler(eventId, matchId);
}
